// extracted by mini-css-extract-plugin
module.exports = {"shadow":"MonitoringStatusPill_shadow__1ycrt","statusPill":"MonitoringStatusPill_statusPill__2emCQ"};